import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import * as config from '../../config/app.config';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'app-request-support',
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './request-support.component.html',
  styleUrls: ['./request-support.component.scss'],
})
export class RequestSupportComponent implements OnInit, OnDestroy {
  emailSubject: Array<Object>;
  baseSiteId: any;
  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly fb: FormBuilder,
    private readonly baseService: BaseService,
    private readonly user: UserAccountFacade,
    private readonly baseSiteSerivce: BaseSiteService,
    private readonly cdr: ChangeDetectorRef
  ) {}
  active = 1;
  requestSupportData: any;
  phoneForm: FormGroup = this.fb.group(
    {
      phone: ['', [Validators.required, Validators.pattern('[0-9-]{12}')]],
      extension: ['', [Validators.pattern('[0-9]+')]],
      cPhone: ['', [Validators.required, Validators.pattern('[0-9-]{12}')]],
      cExtension: ['', [Validators.pattern('[0-9]+')]],
      fName: [
        '',
        [
          Validators.required,
          Validators.pattern("^[a-zA-Z]+(-|'| )?[a-zA-Z]+$"),
        ],
      ],
      lName: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+$')]],
      comments: ['', [Validators.required]],
    },
    { validators: this.checkForMatch }
  );
  emailForm: FormGroup = this.fb.group({
    subject: [null, [Validators.required]],
    other: [''],
    fName: [
      '',
      [Validators.required, Validators.pattern("^[a-zA-Z]+(-|'| )?[a-zA-Z]+$")],
    ],
    lName: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+$')]],
    comments: ['', [Validators.required]],
  });

  requestSuccess: string;
  userData: any;
  baseSub: Subscription;
  baseSub2: Subscription;

  ngOnInit(): void {
    this.baseSub = this.baseSiteSerivce
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.user.get().subscribe((uData: any) => {
      this.userData = uData;
      this.baseService
        .get(
          `${config.USER_ACCOUNT}${uData.userName}/resources/salesRepSupport/requestSupport`,
          { componentId: 'requestSupportComponent' }
        )
        .subscribe((res) => (this.requestSupportData = res));
    });
    this.baseSub2 = this.baseService
      .get('enumeration', { enumerationType: 'EmailSubject', fields: 'BASIC' })
      .subscribe((res) => (this.emailSubject = res));
    this.emailForm.get('subject').valueChanges.subscribe((value) => {
      if (value.code === 'OTHERS') {
        this.emailForm.get('other').setValidators([Validators.required]);
      } else {
        this.emailForm.get('other').clearValidators();
      }
      this.emailForm.get('other').updateValueAndValidity();
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.baseSub2?.unsubscribe();
  }

  getURL() {
    return this.requestSuccess == 'true'
      ? '../../../../assets/icons/confirmation-positive-green.png'
      : '../../../../assets/icons/confirmation-negative-red.png';
  }
  closeModal() {
    this.activeModal.dismiss();
    this.requestSuccess = undefined;
  }

  get EmailControls() {
    return this.emailForm.controls;
  }
  get PhoneControls() {
    return this.phoneForm.controls;
  }

  //async validator

  checkForMatch(control: AbstractControl): ValidationErrors | null {
    let ext = control.get('extension').value;
    let cExt = control.get('cExtension').value;
    return ext && ext != cExt ? { notMatch: true } : null;
  }
  requestService() {
    let req;
    if (this.active == 2) {
      req = {
        emailFirstName: this.EmailControls.fName.value,
        emailLastName: this.EmailControls.lName.value,
        emailPhone: '',
        emailExtension: '',
        emailSubject: this.EmailControls.subject.value.code,
        emailComment: this.EmailControls.comments.value,
        emailContactName: '',
        otherSubject:
          this.EmailControls.subject.value.code === 'OTHERS'
            ? this.EmailControls.other.value
            : '',
        orderStatus: '',
        phone: '',
        confirmPhone: '',
        extension: '',
        confirmExtension: '',
        phoneFirstName: '',
        phoneLastName: '',
        phoneSubject: '',
        customerNumber: '',
        emailRequest: true,
      };
    } else {
      req = {
        emailFirstName: '',
        emailLastName: '',
        emailPhone: '',
        emailExtension: '',
        emailSubject: '',
        emailComment: '',
        emailContactName: '',
        otherSubject: '',
        orderStatus: '',
        phone: this.PhoneControls.phone.value,
        confirmPhone: this.PhoneControls.cPhone.value,
        extension: this.PhoneControls.extension.value,
        confirmExtension: this.PhoneControls.cExtension.value,
        phoneFirstName: this.PhoneControls.fName.value,
        phoneLastName: this.PhoneControls.lName.value,
        phoneSubject: this.PhoneControls.comments.value,
        customerNumber: '',
        emailRequest: false,
      };
    }

    this.baseService
      .post(
        `${config.USER_ACCOUNT}${this.userData.userName}/resources/salesRepSupport/requestSupport`,
        req
      )
      .subscribe((res) => {
        res && res.status === 'success'
          ? (this.requestSuccess = 'true')
          : (this.requestSuccess = ' false');
      });
  }
}
